module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-02@2x.79ee6efe.jpg";